import { useEffect, useState } from "react";
import { onBoardText } from "./OnBordingText";
import OnboardingBaseWindow from "./OnBoardingBaseWindow";

export async function showOnboarding(key: string) {
  setTimeout(() => {
    state.onBoadingManager.openWindowWithKey(key, <OnBoardingWindow keyString={key} />);
  }, 2000);
}

export default function OnBoardingWindow(props: { keyString: string }) {
  const { keyString } = props;
  const [keyText, setKeyText] = useState("");
  const [keyImagePath, setKeyImagePath] = useState("");
  useEffect(() => {
    //checkIfAllreadySeenOrNotAnymoreShow();
    if (keyString) {
      searchTextForKey();
    }
  }, []);

  async function searchTextForKey() {
    function setPicturePath() {
      var image = new Image();
      var url_image = state.hostBaseUrl + `images/onBoarding/${keyString}.gif`;
      image.onload = () => {
        setKeyImagePath(url_image);
      };
      image.onerror = () => {};
      image.src = url_image;
      if (image.width > 0) {
        setKeyImagePath(url_image);
      }
    }
    function setTextFromJson() {
      onBoardText.forEach((elm) => {
        if (elm.key == keyString) {
          setKeyText(elm.text);
        }
      });
    }
    setPicturePath();
    setTextFromJson();
  }

  function onClose(save?: boolean): boolean {
    if (save) {
      let seenKees = state.onBoardingSeenKeys ? (state.onBoardingSeenKeys as Array<string>) : new Array<string>();
      // let seenKees = new Array<string>();
      seenKees.push(keyString);
      state.onBoardingSeenKeys = seenKees;
    }
    return true;
  }

  var imageStyle: any = {
    maxWidth: "300px",
    maxHeight: "300px",
    objectFit: "contain",
  };
  return (
    <OnboardingBaseWindow onOk={onClose}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        {keyImagePath != "" && (
          <img
            draggable="false" // no itx
            style={imageStyle}
            src={keyImagePath}
          />
        )}
        {keyText}
      </div>
    </OnboardingBaseWindow>
  );
}
